import { Fragment } from 'react';

// CMS(캠퍼스소식)에 평문으로 저장된 글을 화면에 그린다.
// 실장님이 **굵게**, "- 목록" 같은 마크다운 표기를 섞어 쓰셔서 그만큼만 해석한다.
//
// 외부 마크다운 라이브러리를 쓰지 않고 React 요소를 직접 만든다.
// dangerouslySetInnerHTML을 거치지 않으므로 본문에 HTML이 섞여 들어와도 그대로 글자로만 보인다.

// **굵게** 처리. 짝이 맞지 않는 **는 그냥 글자로 둔다.
function renderInline(text, keyPrefix) {
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return parts.filter(Boolean).map((part, i) => {
    const m = part.match(/^\*\*([^*]+)\*\*$/);
    return m ? (
      <strong key={`${keyPrefix}-${i}`} className="font-semibold text-primary-text">
        {m[1]}
      </strong>
    ) : (
      <Fragment key={`${keyPrefix}-${i}`}>{part}</Fragment>
    );
  });
}

// 줄 끝 공백(마크다운 줄바꿈 표기)과 캐리지리턴을 정리한다.
function normalize(content) {
  return (content || '').replace(/\r\n/g, '\n').split('\n').map((l) => l.replace(/\s+$/, ''));
}

export default function RichText({ content, className = '' }) {
  const lines = normalize(content);

  // 빈 줄을 기준으로 문단을 나눈다.
  const blocks = [];
  let current = [];
  for (const line of lines) {
    if (line === '') {
      if (current.length) blocks.push(current);
      current = [];
    } else {
      current.push(line);
    }
  }
  if (current.length) blocks.push(current);

  return (
    <div className={className}>
      {blocks.map((block, bi) => {
        const isList = block.every((l) => /^[-*]\s+/.test(l));

        if (isList) {
          return (
            <ul key={bi} className="list-disc pl-[22px] my-[16px] flex flex-col gap-[6px]">
              {block.map((l, li) => (
                <li key={li}>{renderInline(l.replace(/^[-*]\s+/, ''), `${bi}-${li}`)}</li>
              ))}
            </ul>
          );
        }

        return (
          <p key={bi} className="my-[16px] leading-relaxed break-keep">
            {block.map((l, li) => (
              <Fragment key={li}>
                {li > 0 && <br />}
                {renderInline(l, `${bi}-${li}`)}
              </Fragment>
            ))}
          </p>
        );
      })}
    </div>
  );
}
